import React, {useEffect, useState} from 'react';
import AuthContainer from './components/AuthContainer';
import Label from './components/Label';
import {post, setAccessToken} from '../../api';
import LogoRender from '../cmp/LogoRender';
import StyledButton from '../cmp/themed/StyledButton';
import {FormattedMessage} from 'react-intl';
import FormattedHelmet from '../cmp/intl/FormattedHelmet';
import FormInput from './components/FormInput';
import RenderError from './components/RenderError';
import * as localStorage from '../../tools/storage';
import FormGroup from '../cmp/form/FormGroup';
import Checkbox from '../cmp/form/Checkbox';
import {Link, useParams} from 'react-router-dom';
import {emailValidator} from './ForgotPassword';

function ResetPassword() {
    const [email, setEmail] = useState('');
    const params = useParams();
    const [resetkey, setResetKey] = useState(null)
    useEffect(()=>{
        if(params) {
            setResetKey(params.resetkey)
        }
    },[params])
    const [password, setPassword] = useState('')
    const [loading, setLoading] = useState(false)
    const [passwordVisible, setPasswordVisible] = useState(false)
    const [error, setError] = useState(null)
    const [errorCode, setErrorCode] = useState(null)
    const doReset = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        setLoading(true)
        setError(null)
        setErrorCode(null)
        post('/resetpassword', {
            email, password, resetkey
        }).then((data) => {
            if (data.access_token) {
                setAccessToken(data.access_token);
                document.location = '/';
            } else {
                setError(data.error || 'Unexpected error')
                setErrorCode(data.code)
                setLoading(false);
            }
        }).catch((e) => {
            setLoading(false);
        });
    }
         return (
            <AuthContainer>
                <FormattedHelmet id={'resetPassword'}/>
                <div className={'text-center mb-4'}>
                    <LogoRender/>
                </div>
                <h1><FormattedMessage id={'resetPassword'}/></h1>
                <div className={'card shadow-sm'}>
                    <div className={'card-body'}>
                        <form onSubmit={doReset}>
                            {
                                errorCode && <RenderError code={errorCode}/>
                            }
                            {
                                !params.resetkey ?
                                    <div className={'form-group'}>
                                        <Label>Password Reset Code</Label>
                                        <input className={'form-control'} type={'code'}
                                               onChange={(e)=>setResetKey(e.target.value)} value={resetkey}
                                        />
                                    </div> : null
                            }

                            <FormInput id={'emailAddress'}>
                                <input className={'form-control'} autoComplete={'email'} name={'email'} type={'email'}
                                       onChange={(e)=>setEmail(e.target.value)} value={email}/>
                            </FormInput>
                            <FormInput id={'newPassword'}>
                                <input className={'form-control'}
                                       autoComplete={'new-password'}
                                       type={passwordVisible ? 'text' : 'password'}
                                       onChange={(e)=>setPassword(e.target.value)}
                                       value={password}
                                />
                            </FormInput>
                            <FormGroup>
                                <Checkbox label={<FormattedMessage id={"Show password"}/>} checked={passwordVisible}
                                          onChange={(e)=>setPasswordVisible(e.target.checked)} value={'passwordVisible'}/>
                            </FormGroup>
                            <div className={'form-group'}>
                                <StyledButton loading={loading} disabled={!resetkey || !email || !password || !emailValidator.test(email)} className={'btn btn-primary'}>
                                    <FormattedMessage id={'resetPassword'}/>
                                </StyledButton>
                            </div>
                        </form>
                    </div>
                </div>
                {
                    errorCode &&
                    <div className="mt-2 text-center">
                        <Link to={"/forgot-password"}><FormattedMessage id={"forgotPassword"}/></Link>
                    </div>
                }
            </AuthContainer>
        );
}

export default ResetPassword;
